export const T = {
  en_GB: {
    unmatchedTitle: (count: number) =>
      count === 1
        ? "1 existing holding could not be mapped to a product and is excluded from the figures above:"
        : `${count} existing holdings could not be mapped to a product and are excluded from the figures above:`,
  },
  nb_NO: {
    unmatchedTitle: (count: number) =>
      count === 1
        ? "1 eksisterende beholdning kunne ikke kobles til et produkt og er holdt utenfor tallene over:"
        : `${count} eksisterende beholdninger kunne ikke kobles til et produkt og er holdt utenfor tallene over:`,
  },
} as const;
